import React, { useContext, useEffect, useState } from 'react'
import Footer from './Footer/Footer'
import SearchLocationContext from '../context/SearchLocationContext'
import LocationUtilities from '../utilities/LocationUtilities'
import ApplicationContext from '../context/ApplicationContext'
import LocationsDisplayContainer from './LocationsDisplayContainer/LocationsDisplayContainer'

const Container = () => {
    const [applicationData] = useContext(ApplicationContext)
    const [localizations] = useState(applicationData.localizations)
    const [searchLocationData, setSearchLocationData] = useState({
        locationList: [],
        activeLocationId: null,
        eventsListingActiveLocationId: null,
        highlightedLocationId: null,
        queryParamLocationSet: applicationData.queryParamLocationSet,
        unitType: applicationData.unitType,
        mapCenter: {
            lat: applicationData.queryParamLocationSet?.lat ?? applicationData.defaultLat,
            lng: applicationData.queryParamLocationSet?.lng ?? applicationData.defaultLong,
        },
        defaultZoom: applicationData.defaultZoom,
        sortBy: applicationData.sort,
        hideSort: applicationData.hideSort,
        appliedFilters: applicationData.filters,
        language: applicationData.language,
        availableFilterCategories: [],
        address: null,
        radius: applicationData.radius,
        locationsLoading: false,
        detailsLoading: false,
        filtersLoading: false,
        disableRoamingRequest: false,
    })

    useEffect(() => {
        const searchBody = LocationUtilities.generateSearchBody(searchLocationData)
        if (searchLocationData?.availableFilterCategories?.length > 0) {
            if (applicationData?.selectedFilterNames) {
                var filterNames = applicationData.selectedFilterNames.map(sfn => sfn?.toLowerCase())
                var allFilterOptions = searchLocationData?.availableFilterCategories?.map(afc => afc?.filters)
                allFilterOptions = allFilterOptions?.flat()
                var filtersToSelect = allFilterOptions?.filter(
                    afo => filterNames.includes(afo?.displayName?.toLowerCase()) || filterNames.includes(afo?.title?.toLowerCase())
                )

                if (filtersToSelect?.length > 0) {
                    setSearchLocationData(prevState => {
                        return {
                            ...prevState,
                            appliedFilters: filtersToSelect,
                        }
                    })
                    searchBody.filters = filtersToSelect.map(fts => fts?.value)
                }
            }

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    position => {
                        if (
                            !searchLocationData.queryParamLocationSet &&
                            typeof position?.coords?.latitude === 'number' &&
                            typeof position?.coords?.longitude === 'number'
                        ) {
                            searchBody.latitude = position.coords.latitude
                            searchBody.longitude = position.coords.longitude
                            const pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            }
                            setSearchLocationData(prevState => {
                                return {
                                    ...prevState,
                                    mapCenter: pos,
                                }
                            })
                        }
                        getLocations(searchBody)
                    },
                    () => {
                        // eslint-disable-next-line
                        // if geolocation fails, use default location
                        getLocations(searchBody)
                    }
                )
            }
        }
    }, [applicationData.selectedFilterNames, searchLocationData.availableFilterCategories])

    const getLocations = searchBody => {
        LocationUtilities.postSearchLocations(searchBody)
            .then(response => {
                setSearchLocationData(prevState => {
                    return {
                        ...prevState,
                        locationsLoading: false,
                        locationList: response?.data?.data,
                    }
                })
            })
            .catch(() => {
                setSearchLocationData(prevState => {
                    return {
                        ...prevState,
                        locationsLoading: false,
                        error: true,
                    }
                })
            })
    }

    useEffect(() => {
        setSearchLocationData(prevState => {
            return {
                ...prevState,
                locationsLoading: true,
                filtersLoading: true,
                disableRoamingRequest: true,
            }
        })

        Promise.all([LocationUtilities.getFilters(), LocationUtilities.getEventTypes()])
            .then(responses => {
                const filtersResponse = responses[0]
                const eventTypesResponse = responses[1]

                const formattedEventsFilters = [
                    {
                        parentCategory: localizations.events,
                        category: localizations.eventType,
                        filters: eventTypesResponse.data.data
                            .map(eventType => {
                                return {
                                    displayName: eventType.name,
                                    groupName: eventType.name,
                                    title: eventType.name,
                                    value: eventType.id,
                                    isEventFilter: true,
                                }
                            })
                            .sort((a, b) => {
                                if (a.title.toLowerCase().includes('fitting day')) {
                                    return -1
                                }
                                if (b.title.toLowerCase().includes('fitting day')) {
                                    return 1
                                }
                                return 0
                            }),
                    },
                    {
                        parentCategory: localizations.events,
                        category: localizations.mobileFitting,
                        filters: [
                            {
                                displayName: localizations.pingMobileFittingExperience,
                                groupName: localizations.pingMobileFittingExperience,
                                title: localizations.pingMobileFittingExperience,
                                value: '',
                                isMobileFittingFilter: true,
                            },
                        ],
                    },
                ]

                setSearchLocationData(prevState => {
                    return {
                        ...prevState,
                        filtersLoading: false,
                        availableFilterCategories: [...formattedEventsFilters, ...filtersResponse.data.data],
                        disableRoamingRequest: false,
                    }
                })
            })
            .catch(() => {
                setSearchLocationData(prevState => {
                    return {
                        ...prevState,
                        filtersLoading: false,
                        filtersError: true,
                        disableRoamingRequest: false,
                    }
                })
            })
    }, [])

    return (
        <div>
            <SearchLocationContext.Provider value={[searchLocationData, setSearchLocationData]}>
                <main>
                    <LocationsDisplayContainer />
                </main>
            </SearchLocationContext.Provider>
            {applicationData.footer && <Footer />}
        </div>
    )
}

export default Container
